var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { Component, Mixins, Watch } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';
import { Notification } from '@/common/services/notificationService';
import { AttachmentsCollection } from '@/common/types/AttachmentsCollection';
import { Savable } from '@/common/mixins/Savable';
import { Focusable } from '@/common/mixins/Focusable';
import { Language } from '@/common/types/Language';
import ValidationErrors from '@/common/components/ValidationErrorsControl.vue';
import TextInputRow from '@/common/components/TextInputRow.vue';
import BusinessIdRow from '@/common/components/BusinessIdRow.vue';
import RadioButtonRow from '@/common/components/RadioButtonRow.vue';
import RadioButtonOptionRow from '@/common/components/RadioButtonOptionRow.vue';
import CheckBoxControl from '@/common/components/CheckBoxControl.vue';
import OrganisationContactControl from '@/template/components/organisation/OrganisationContactControl.vue';
import Attachments from '@/template/components/organisation/Attachments.vue';
import EntityService from "@/common/services/EntityService";
import OrganisationService from '@/common/services/OrganisationService';
import SteaContactControl from '@/template/components/organisation/SteaContactControl.vue';
import moment from 'moment';
var OrganisationInformationView = /** @class */ (function (_super) {
    __extends(OrganisationInformationView, _super);
    function OrganisationInformationView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.sending = false;
        _this.organisationService = new OrganisationService();
        _this.entityService = new EntityService();
        _this.organisation = {};
        _this.contacts = [];
        _this.languageOptions = [
            { id: Language.Finnish, name: "Language.Fi" },
            { id: Language.Swedish, name: "Language.Sv" }
        ];
        _this.attachments = [];
        _this.hasNeverUpdatedAttachments = true;
        return _this;
    }
    OrganisationInformationView.prototype.onAttachmentsAreSameChanged = function () {
        if (this.organisation.attachmentsAreSame) {
            this.attachments = [];
        }
        else {
            this.attachments.push({ displayKey: "Organisation.Attachments.Attachment1", name: this.$t("Organisation.Attachments.Attachment1"), isRequired: true, blobUri: null });
            this.attachments.push({ displayKey: "Organisation.Attachments.Attachment2", name: this.$t("Organisation.Attachments.Attachment2"), isRequired: true, blobUri: null });
        }
    };
    OrganisationInformationView.prototype.onAttachmentChanged = function (attachments) {
        var e_1, _a;
        if (this.organisation.attachmentsAreSame)
            return;
        try {
            for (var attachments_1 = __values(attachments), attachments_1_1 = attachments_1.next(); !attachments_1_1.done; attachments_1_1 = attachments_1.next()) {
                var attachment = attachments_1_1.value;
                switch (attachment.displayKey) {
                    case "Organisation.Attachments.Attachment1":
                        this.organisation.registrationCertificationUri = attachment.blobUri;
                        break;
                    case "Organisation.Attachments.Attachment2":
                        this.organisation.organisationRulesUri = attachment.blobUri;
                        break;
                    default:
                        break;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (attachments_1_1 && !attachments_1_1.done && (_a = attachments_1.return)) _a.call(attachments_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    Object.defineProperty(OrganisationInformationView.prototype, "language", {
        get: function () {
            return this.$i18n.locale;
        },
        enumerable: false,
        configurable: true
    });
    OrganisationInformationView.prototype.onLanguageChange = function () {
        this.observer.validate();
    };
    Object.defineProperty(OrganisationInformationView.prototype, "attachmentsLastUpdatedText", {
        get: function () {
            var attachmentsUpdatedDate = moment(this.organisation.attachmentsUpdatedDate).format("DD.MM.YYYY");
            return "(" + this.$t("Organisation.AttachmentsLastUpdatedText") + attachmentsUpdatedDate + ")";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OrganisationInformationView.prototype, "hasProcuration", {
        get: function () {
            return this.$store.state.vuexPageModule.currentUser.hasProcuration;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OrganisationInformationView.prototype, "postalCodeRules", {
        get: function () {
            return { postalCode: true };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OrganisationInformationView.prototype, "phoneRules", {
        get: function () {
            return { phone: true };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OrganisationInformationView.prototype, "emailRules", {
        get: function () {
            return { email: true };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OrganisationInformationView.prototype, "emailMaxLength", {
        get: function () {
            return this.$store.state.vuexPageModule.configuration.emailMaxLength;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OrganisationInformationView.prototype, "organisationLanguage", {
        get: function () {
            return this.organisation.language != Language.NULL
                ? this.organisation.language
                : undefined;
        },
        set: function (language) {
            this.organisation.language = language;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OrganisationInformationView.prototype, "loading", {
        get: function () {
            return this.$store.state.vuexPageModule.loading;
        },
        set: function (value) {
            this.$store.commit("vuexPageModule/SET_LOADING", value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OrganisationInformationView.prototype, "observer", {
        get: function () {
            return this.$refs["organisationObserver"];
        },
        enumerable: false,
        configurable: true
    });
    OrganisationInformationView.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, e_2;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 3, 4, 5]);
                        this.loading = true;
                        _a = this;
                        return [4 /*yield*/, this.organisationService.getOrganisation()];
                    case 1:
                        _a.organisation = _c.sent();
                        _b = this;
                        return [4 /*yield*/, this.organisationService.getOrganisationContacts()];
                    case 2:
                        _b.contacts = _c.sent();
                        if (!this.organisation.attachmentsUpdatedDate) {
                            this.organisation.attachmentsAreSame = false;
                        }
                        else {
                            this.organisation.attachmentsAreSame = true;
                            this.hasNeverUpdatedAttachments = false;
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        e_2 = _c.sent();
                        console.error(e_2);
                        return [3 /*break*/, 5];
                    case 4:
                        this.loading = false;
                        return [7 /*endfinally*/];
                    case 5: return [4 /*yield*/, this.$nextTick()];
                    case 6:
                        _c.sent();
                        this.observer.validate();
                        this.focusOnFirstTag("h1");
                        return [2 /*return*/];
                }
            });
        });
    };
    OrganisationInformationView.prototype.validateForm = function (valid) {
        var attachmentsAreValid = this.organisation.attachmentsAreSame || (this.attachments && this.attachments.every(function (x) { return x.blobUri !== null; }));
        if (!new AttachmentsCollection(this.attachments).attachmentsFileNamesAreUnique()) {
            attachmentsAreValid = false;
        }
        var radiobuttonsAreValid = (this.organisation.language == Language.Finnish || this.organisation.language == Language.Swedish) && (this.organisation.hasConvictionOrSanction == true || this.organisation.hasConvictionOrSanction == false);
        return valid && attachmentsAreValid && radiobuttonsAreValid;
    };
    OrganisationInformationView.prototype.isSendBtnDisabled = function (valid) {
        return this.sending || !this.validateForm(valid);
    };
    OrganisationInformationView.prototype.saveAndStartApplication = function () {
        return __awaiter(this, void 0, void 0, function () {
            var obs, isValid, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.sending = true;
                        return [4 /*yield*/, this.$refs["organisationObserver"]];
                    case 1:
                        obs = _a.sent();
                        return [4 /*yield*/, obs.validate()];
                    case 2:
                        isValid = _a.sent();
                        if (!this.validateForm(isValid)) return [3 /*break*/, 7];
                        this.loading = true;
                        if (!this.organisation.attachmentsAreSame) {
                            this.organisation.attachmentsUpdatedDate = new Date(Date.now());
                        }
                        return [4 /*yield*/, this.organisationService.saveOrganisation(this.organisation, this.organisation.crmOrganisationId)];
                    case 3:
                        response = _a.sent();
                        if (!response.ok) return [3 /*break*/, 5];
                        this.lock = false;
                        this.dirty = false;
                        this.modified = false;
                        Notification.success(this, this.$t("Organisation.Saving.Succeeded").toString());
                        return [4 /*yield*/, this.createApplication()];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        Notification.error(this, this.$t("Organisation.Saving.Error").toString());
                        _a.label = 6;
                    case 6:
                        this.loading = false;
                        this.sending = false;
                        _a.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    OrganisationInformationView.prototype.createApplication = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var aidTypeId, aidTargetId, response, aidApplicationId;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        aidTypeId = Number(this.$route.params.aidType);
                        aidTargetId = this.$route.params.aidTargetId;
                        return [4 /*yield*/, this.entityService.createAidApplication(aidTypeId, aidTargetId)];
                    case 1:
                        response = _b.sent();
                        if (!response.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.json()];
                    case 2:
                        aidApplicationId = _b.sent();
                        this.$router.push({ name: "aidApplication", params: { id: aidApplicationId } });
                        return [3 /*break*/, 4];
                    case 3:
                        if (((_a = response) === null || _a === void 0 ? void 0 : _a.status) == 409) {
                            Notification.error(this, this.$t("AidApplication.ExtensionAlreadyExists").toString());
                            this.$router.push({ name: "frontPage" });
                        }
                        else {
                            Notification.error(this, this.$t("Entities.SaveFailed").toString());
                        }
                        _b.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    OrganisationInformationView.prototype.waitUntilSaved = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.dirty = false;
                return [2 /*return*/];
            });
        });
    };
    Object.defineProperty(OrganisationInformationView.prototype, "isNewApplicationSituation", {
        get: function () {
            return (Number(this.$route.params.aidType) > 0);
        },
        enumerable: false,
        configurable: true
    });
    OrganisationInformationView.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var obs, isValid, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.sending = true;
                        return [4 /*yield*/, this.$refs["organisationObserver"]];
                    case 1:
                        obs = _a.sent();
                        return [4 /*yield*/, obs.validate()];
                    case 2:
                        isValid = _a.sent();
                        if (!this.validateForm(isValid)) return [3 /*break*/, 4];
                        this.loading = true;
                        if (!this.organisation.attachmentsAreSame) {
                            this.organisation.attachmentsUpdatedDate = new Date(Date.now());
                        }
                        return [4 /*yield*/, this.organisationService.saveOrganisation(this.organisation, this.organisation.crmOrganisationId)];
                    case 3:
                        response = _a.sent();
                        if (response.ok) {
                            this.lock = false;
                            this.dirty = false;
                            this.modified = false;
                            Notification.success(this, this.$t("Organisation.Saving.Succeeded").toString());
                            this.$router.push({ name: "frontPage" });
                        }
                        else {
                            Notification.error(this, this.$t("Organisation.Saving.Error").toString());
                        }
                        this.loading = false;
                        this.sending = false;
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    __decorate([
        Watch("organisation.attachmentsAreSame"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], OrganisationInformationView.prototype, "onAttachmentsAreSameChanged", null);
    __decorate([
        Watch("attachments", { deep: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], OrganisationInformationView.prototype, "onAttachmentChanged", null);
    __decorate([
        Watch("language"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], OrganisationInformationView.prototype, "onLanguageChange", null);
    OrganisationInformationView = __decorate([
        Component({
            name: "OrganisationInformationView",
            components: {
                ValidationObserver: ValidationObserver,
                ValidationErrors: ValidationErrors,
                TextInputRow: TextInputRow,
                BusinessIdRow: BusinessIdRow,
                RadioButtonRow: RadioButtonRow,
                RadioButtonOptionRow: RadioButtonOptionRow,
                CheckBoxControl: CheckBoxControl,
                OrganisationContactControl: OrganisationContactControl,
                Attachments: Attachments,
                SteaContactControl: SteaContactControl
            }
        })
    ], OrganisationInformationView);
    return OrganisationInformationView;
}(Mixins(Savable, Focusable)));
export default OrganisationInformationView;
